import { StarFilled } from '@ant-design/icons';
import { Button, Switch, Table } from 'antd';
import axios from 'axios';
import React, { useEffect, useState } from 'react';

function Comments(props) {
    let columns = [
        {
            title: 'Id',
            dataIndex: 'id',
            key: 'id',
        },
        {
            title: 'Maxsulot',
            dataIndex: 'nameuz',
            key: 'nameuz',
        },
        {
            title: 'Foydalanuvchi',
            dataIndex: 'username',
            key: 'username',
        },
        {
            title: 'Fikrlar',
            dataIndex: 'comment',
            key: 'comment',
        },
        {
            title: 'Baho',
            dataIndex: 'rating',
            key: 'rating',
            render: (text, record) => {
                return (
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <StarFilled style={{ color: 'gold' }} />
                        {text}
                    </div>
                )
            }
        },
        {
            title: 'Xolati',
            dataIndex: 'status',
            key: 'status',
            render: (text, record) => {
                return (
                    <Switch checked={text} onChange={(e) => {
                        axios.put(`/comments/${record.id}`, { status: e }).then(res => {
                            axios.get('/comments').then(res => {
                                setData(res.data)
                            })
                        })
                    }} />
                )
            }
        },
        {
            title: "O'chirish",
            dataIndex: 'action',
            key: 'action',
            render: (text, record) => {
                return (
                    <Button type="primary" danger onClick={() => {
                        axios.delete(`/comments/${record.id}`).then(res => {
                            axios.get('/comments').then(res => {
                                setData(res.data)
                            })
                        })
                    }}>O'chirish</Button>
                )
            }
        }
    ]
    let [data, setData] = useState([])
    useEffect(() => {
        axios.get('/comments').then(res => {
            setData(res.data)
        })
    }, [])
    return (
        <Table columns={columns} dataSource={data} />
    );
}

export default Comments;